import { render } from "./Electronics.vue?vue&type=template&id=c47b97ae"
import script from "./Electronics.vue?vue&type=script&lang=js"
export * from "./Electronics.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__